<div class="modal-header">
    <h5 class="modal-title">Rename Master File</h5>
    <button type="button" class="btn-close" (click)="dismiss()" aria-label="Close"></button>
</div>
<dirty-tracking [forms]="[fileForm]"></dirty-tracking>
<form class="" novalidate #fileForm="ngForm" [ngClass]="{'was-validated': submitAttempt}">
    <div class="modal-body">
        <label class="mb-1">Name</label>
        <input type="text" class="form-control" id="FileName" name="FileName" placeholder="File Name" required [(ngModel)]="uploadInfo.commonName">
        <div class="invalid-feedback">
            <i class="fas fa-exclamation-circle"></i> This field is required.
        </div>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-outline-black btn-round btn-lg" (click)="dismiss()"><i class="far fa-times"></i> Cancel</button>
        <button type="submit" class="btn btn-secondary btn-round btn-lg" (click)="save()"><i class="far fa-check"></i>Save</button>
    </div>
</form>